export default __webpack_public_path__ + "static/media/totalEnergySaving.6f4eb355.svg";